export { default } from './CarouselWIP';
export type { CarouselWIPProps, CarouselWIPImage } from './CarouselWIP.types';
